"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVueModel = exports.VueModel = void 0;
var model_js_1 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var model_js_2 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var vue_internals_1 = require("./vue-internals");
var vue_global_mixin_1 = require("./vue-global-mixin");
var source_path_mixin_1 = require("./source-path-mixin");
var source_root_mixin_1 = require("./source-root-mixin");
var vue_model_observability_1 = require("./vue-model-observability");
var vm_root_component_1 = require("./vm-root-component");
var vm_source_component_1 = require("./vm-source-component");
var model_js_3 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
// TODO: Do we need to take `toggleObserving()` into account?
var VueModel = /** @class */ (function (_super) {
    __extends(VueModel, _super);
    /**
     * Creates a new model with the specified type information.
     * @param options The set of model types to add.
     */
    function VueModel(options, config) {
        var _this = _super.call(this, options, config) || this;
        if (!VueModel._Vue) {
            // TODO: auto-install if needed?
            throw new Error("Vue.use(VueModel) must be called before constructing a VueModel instance.");
        }
        // Make sure that the model itself is not made observable by Vue, since anything that we want to be made observable should be made observable explicitly
        (0, vue_model_observability_1.preventVueObservability)(_this);
        // Make sure that entities are observable by Vue
        (0, vue_model_observability_1.makeEntitiesVueObservable)(_this);
        return _this;
    }
    /**
     * Implement the Vue plugin interface:
     * https://vuejs.org/v2/guide/plugins.html#Writing-a-Plugin
     */
    VueModel.install = function (vue) {
        // Detect if the plugin install has already been called
        if (VueModel._Vue)
            return;
        // Register components globally for use in templates
        vue.component("vm-root", vm_root_component_1.VMRoot);
        vue.component("vm-source", vm_source_component_1.VMSource);
        // Store a reference to the Vue constructor/module
        VueModel._Vue = vue;
        // Get access to Vue's internal types that we need
        (0, vue_internals_1.ensureVueInternalTypes)(VueModel._VueInternals, VueModel._Vue);
        // Install the Vue global mixin
        return (0, vue_global_mixin_1.VueModel$installGlobalMixin)(vue);
    };
    VueModel._Vue = null;
    VueModel._VueInternals = { Observer: null, Dep: null };
    /**
     * Provide access to Vue mixins for source provider/consumer
     */
    VueModel.mixins = {
        SourcePath: source_path_mixin_1.SourcePathMixin,
        SourceRoot: source_root_mixin_1.SourceRootMixin
    };
    VueModel.Entity = model_js_2.Entity;
    VueModel.CultureInfo = model_js_3.CultureInfo;
    return VueModel;
}(model_js_1.Model));
exports.VueModel = VueModel;
// eslint-disable-next-line no-redeclare
function createVueModel(options, config) {
    return new Promise(function (resolve) {
        var model = new VueModel(options, config);
        model.ready(function () {
            resolve(model);
        });
    });
}
exports.createVueModel = createVueModel;
